import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    影视分类: [
      { name: '电影', path: '/category/movie' },
      { name: '电视剧', path: '/category/tv-series' },
      { name: '综艺', path: '/category/variety' },
      { name: '动漫', path: '/category/anime' },
      { name: '纪录片', path: '/category/documentary' },
    ],
    关于我们: [
      { name: '品牌介绍', path: '/about' },
      { name: '用户口碑', path: '/about#reputation' },
      { name: '联系我们', path: '/about#contact' },
    ],
    服务支持: [
      { name: '播放帮助', path: '#' },
      { name: '问题反馈', path: '#' },
      { name: '版权声明', path: '#' },
    ],
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-clapperboard-line text-2xl"></i>
              </div>
              <span className="text-xl font-heading font-bold tracking-wide whitespace-nowrap text-background-50">
                西瓜影院
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              西瓜影院提供海量免费电影、电视剧、综艺在线观看，无需下载、无需付费、无需等待缓冲，高清画质流畅播放，最新热播剧集和热门大片一网打尽。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 西瓜影院 xiguayingyuan.com 版权所有 | 本站内容仅供学习交流使用
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}